





























































































import AddEncodeDialog from '@/components/encode/AddEncodeDialog.vue';
import MoveToExternalDialog from '@/components/recorded/MoveToExternalDialog.vue';
import RecordedDeleteDialog from '@/components/recorded/RecordedDeleteDialog.vue';
import IRecordedApiModel from '@/model/api/recorded/IRecordedApiModel';
import container from '@/model/ModelContainer';
import IServerConfigModel from '@/model/serverConfig/IServerConfigModel';
import ISnackbarState from '@/model/state/snackbar/ISnackbarState';
import StrUtil from '@/util/StrUtil';
import Util from '@/util/Util';
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as apid from '../../../../api';

@Component({
    components: {
        AddEncodeDialog,
        MoveToExternalDialog,
        RecordedDeleteDialog,
    },
})
export default class RecordedItemMenu extends Vue {
    @Prop({
        required: true,
    })
    public recordedItem!: apid.RecordedItem;

    public isOpened: boolean = false;
    public isOpenDeleteDialog: boolean = false;
    public isOpenEncodeDialog: boolean = false;
    public isOpenMoveToExternalDialog: boolean = false;

    public serverConfig: IServerConfigModel = container.get<IServerConfigModel>('IServerConfigModel');
    public recordedApiModel = container.get<IRecordedApiModel>('IRecordedApiModel');
    private snackbarState: ISnackbarState = container.get<ISnackbarState>('ISnackbarState');

    public async gotoRule(): Promise<void> {
        if (typeof this.recordedItem.ruleId === 'undefined') {
            return;
        }

        await Util.sleep(300);
        Util.move(this.$router, {
            path: '/search',
            query: {
                rule: this.recordedItem.ruleId.toString(10),
            },
        });
    }

    public async search(): Promise<void> {
        await Util.sleep(300);

        if (typeof this.recordedItem.ruleId !== 'undefined') {
            Util.move(this.$router, {
                path: '/recorded',
                query: {
                    ruleId: this.recordedItem.ruleId.toString(10),
                },
            });

            return;
        }

        // recorded 絞り込み
        Util.move(this.$router, {
            path: '/recorded',
            query: {
                keyword: StrUtil.createSearchKeyword(this.recordedItem.name),
            },
        });
    }

    public async unprotect(): Promise<void> {
        try {
            await this.recordedApiModel.unprotect(this.recordedItem.id);
            this.snackbarState.open({
                color: 'success',
                text: '保護解除に成功',
            });
        } catch (err) {
            this.snackbarState.open({
                color: 'error',
                text: '保護解除に失敗',
            });
        }
    }

    public async protect(): Promise<void> {
        try {
            await this.recordedApiModel.protect(this.recordedItem.id);
            this.snackbarState.open({
                color: 'success',
                text: '保護に成功',
            });
        } catch (err) {
            this.snackbarState.open({
                color: 'error',
                text: '保護に失敗',
            });
        }
    }

    public async stopEncode(): Promise<void> {
        this.$emit('stopEncode', this.recordedItem.id);
    }

    public async requestTranscribe(): Promise<void> {
        try {
            await this.recordedApiModel.requestTranscribe(this.recordedItem.id);
            this.snackbarState.open({
                color: 'success',
                text: '文字起こしジョブを投入しました',
            });
        } catch (err) {
            this.snackbarState.open({
                color: 'error',
                text: '文字起こし要求に失敗しました',
            });
        }
    }

    public async openDeleteDialog(): Promise<void> {
        await Util.sleep(300);
        this.isOpenDeleteDialog = true;
    }

    public async openEncodeDialog(): Promise<void> {
        await Util.sleep(300);
        this.isOpenEncodeDialog = true;
    }

    public async openMoveToExternalDialog(): Promise<void> {
        await Util.sleep(300);
        this.isOpenMoveToExternalDialog = true;
    }

    public onClickMenuBackground(e: Event): boolean {
        e.stopPropagation();

        return false;
    }
}
